function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { BackgroundStyle } from './layout.theme.utils';

var getContentPadding = paddingContent => paddingContent ? {
  padding: paddingContent
} : {
  paddingX: {
    xs: 's',
    s: 'xxl'
  },
  paddingY: {
    xs: 's',
    s: 'xl',
    xl: 'xxl'
  }
};

export var layoutTheme = {
  baseStyle: _ref => {
    var {
      columns,
      isLoading,
      backgroundColor,
      paddingContent
    } = _ref;
    return {
      container: {
        height: '100%',
        width: '100%',
        backgroundColor: BackgroundStyle[backgroundColor],
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        justifyContent: isLoading ? 'center' : 'unset'
      },
      header: {
        width: '100%',
        flexShrink: 0
      },
      content: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        alignItems: 'center',
        overflow: 'auto'
      },
      grid: _objectSpread({
        display: 'grid',
        gridTemplateColumns: "repeat(".concat(columns, ", minmax(0, 1fr))"),
        gridTemplateRows: '1fr',
        height: 'auto',
        width: '100%',
        gap: {
          xs: 's',
          s: 'm'
        },
        maxWidth: '1638px',
        flexGrow: 1
      }, getContentPadding(paddingContent)),
      gridItem: {
        gridColumnStart: 1,
        gridColumnEnd: -1,
        display: 'flex',
        flexDirection: 'column',
        gap: {
          xs: 'm',
          s: 'l',
          xl: 'xl'
        },
        width: '100%'
      },
      footer: {
        width: '100%',
        flexShrink: 0
      }
    };
  },
  variants: {
    full: {
      gridItem: {
        gridColumnStart: 1,
        gridColumnEnd: -1
      }
    },
    '6Columns': {
      gridItem: {
        gridColumnStart: {
          xs: 1,
          s: 2,
          m: 3,
          l: 3,
          xl: 6
        },
        gridColumnEnd: {
          xs: -1,
          s: -2,
          m: -3,
          l: -3,
          xl: -6
        }
      }
    },
    '8Columns': {
      gridItem: {
        gridColumnStart: {
          xs: 1,
          s: 2,
          m: 3,
          l: 3,
          xl: 5
        },
        gridColumnEnd: {
          xs: -1,
          s: -2,
          m: -3,
          l: -3,
          xl: -5
        }
      }
    },
    '10Columns': {
      gridItem: {
        gridColumnStart: {
          xs: 1,
          s: 1,
          m: 2,
          l: 2,
          xl: 4
        },
        gridColumnEnd: {
          xs: -1,
          s: -1,
          m: -2,
          l: -2,
          xl: -4
        }
      }
    },
    '12Columns': {
      gridItem: {
        gridColumnStart: {
          xs: 1,
          s: 1,
          m: 2,
          l: 2,
          xl: 3
        },
        gridColumnEnd: {
          xs: -1,
          s: -1,
          m: -2,
          l: -2,
          xl: -3
        }
      }
    },
    '14Columns': {
      gridItem: {
        gridColumnStart: {
          xs: 1,
          s: 1,
          m: 1,
          l: 2,
          xl: 2
        },
        gridColumnEnd: {
          xs: -1,
          s: -1,
          m: -1,
          l: -2,
          xl: -2
        }
      }
    }
  }
};
//# sourceMappingURL=Layout.theme.js.map